(function () {

    'use strict';

    angular.module('Services').factory('PendingZoneImportTableService', PendingZoneImportTableService);

    PendingZoneImportTableService.$inject = ['Carrier', 'TableLiteFactory','toastr'];

    function PendingZoneImportTableService(Carrier, TableLiteFactory, toastr) {
        return function (paramId, countries) {
            let zoneTable = {
                config: {
                    noExtract: true
                },
                headers: [{
                    label: 'ZONE NAME',
                    viewName: 'name',
                    filterName: 'name',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: header => {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'ZONE CODE',
                    viewName: 'code',
                    filterName: 'code',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: ''
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'COUNTRY',
                    viewName: 'countryName',
                    filterName: 'country.code',
                    filter: {
                        type: 'select2',
                        viewName: 'name',
                        filterBy: 'code',
                        placeholder: 'Search',
                        class: 'table-input',
                        items: countries,
                        onSelect: header => {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }],
                data: []
            };
            const tableActions = new TableLiteFactory(zoneTable,
                {
                    serviceCallback: Carrier.getZonePostcodeFileDetail,
                    callbackFormat: ['id', 'success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters: {
                        size: 10,
                        page: 0,
                        sort: 'id,desc',
                        draft: true
                    },
                    paramId: paramId
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (row) {
                    row.countryName = angular.getObjVal(row, 'country.name');
                    zoneTable.data.push(row);
                })
            }

            this.tableData = zoneTable;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/tables/PendingZoneImportTableService.js